( function( $ ) {
    var IdrogenoSearchPanelClass = {};
    IdrogenoSearchPanelClass.run = function(panelInstance){
        // private variables
        var thisSearchPanel = $(panelInstance);
        if (!$(thisSearchPanel).hasClass("ssnail-search-panel")) {
            thisSearchPanel = $(panelInstance).closest(".ssnail-search-panel");
        }

        // private methods
        var setPosition = function() {
            switch (true) {
                case thisSearchPanel.hasClass('full-page'):
                    var navbar = $("nav.navbar.ssnail-navigation").first();
                    if (navbar.length === 1) {
                        thisSearchPanel.css({
                            "top": (navbar.offset().top + navbar.outerHeight() + 1) + "px",
                            "left": navbar.offset().left + "px"
                        });
                    }
                    break;
                case thisSearchPanel.hasClass('compact'):
                    var navbar = $("nav.navbar.ssnail-navigation").first();
                    var gap = 1;
                    if (thisSearchPanel.hasClass('compact')) {
                        gap = 0;
                    }
                    if (navbar.length === 1) {
                        thisSearchPanel.css({
                            "top": (navbar.offset().top + navbar.outerHeight() - $(window).scrollTop()) + "px",
                            "left": navbar.offset().left + "px"
                        });
                    }
                    break;
                default:
                    var trigger = $(".ssnail-search-panel-trigger:visible").first()
                    if (trigger.length === 1) {
                        thisSearchPanel.css({
                            "top": (trigger.offset().top + (trigger.outerHeight() / 2) - (thisSearchPanel.outerHeight() / 2)) + "px",
                            "left": "initial",
                            "right": ($(window).width() - trigger.offset().left - trigger.outerWidth()) + "px",
                        });
                    }
            }
        };
        var toggle = function() {
            if (thisSearchPanel.hasClass('open')) {
                close();
            } else {
                open();
            }
        };
        var open = function() {
            if (!thisSearchPanel.hasClass('open')) {
                if (!thisSearchPanel.hasClass('full-page')) {
                    setPosition();
                }
                $(".ssnail-navigation .navbar-collapse").removeClass("show");
                $(".ssnail-navigation .navbar-toggler").first().addClass("collapsed");
                togglePanelTrigger('open');
                setTimeout(function(){
                    thisSearchPanel.find('input').first().focus();
                }, 100);
                if (thisSearchPanel.hasClass('full-page')) {
                    changeScrollStatus(false);
                }
            }
            thisSearchPanel.addClass('open');
        };
        var close = function() {
            if (thisSearchPanel.hasClass('open')) {
                togglePanelTrigger('close');
                if (thisSearchPanel.hasClass('full-page')) {
                    changeScrollStatus(true);
                }
            }
            thisSearchPanel.removeClass('open');
        };
        var changeScrollStatus = function(enable = true) {
            // https://www.geeksforgeeks.org/how-to-disable-scrolling-temporarily-using-javascript/
            if (enable) {
                window.onscroll = function() {};
            } else {
                scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
                window.onscroll = function() {
                    window.scrollTo(scrollLeft, scrollTop);
                };
            }
        };
        var togglePanelTrigger = function(action) {
            $(".ssnail-search-panel-trigger").each(function() {
                if (action === 'close') {
                    $(this).removeClass('opened').addClass('closed');
                } else {
                    $(this).addClass('opened').removeClass('closed');
                }
            });
        };

        // public API
        return {
            setPosition: setPosition,
            toggle: toggle,
            open: open,
            close: close
        };
    };

    var searchPanelPositioningTimer = null;
    var ssnailSearchPanel = new IdrogenoSearchPanelClass.run($(".ssnail-search-panel").first());

    $(".ssnail-search-panel-trigger").on("click", function(event){
        event.stopPropagation();
        ssnailSearchPanel.toggle();
    });
    $(window).resize(function () {
        if (searchPanelPositioningTimer !== null) {
            clearTimeout(searchPanelPositioningTimer);
        }
        searchPanelPositioningTimer = setTimeout(function(){
            ssnailSearchPanel.setPosition();
        }, 300);
    }).resize();
    $(window).scroll(function () {
        if (searchPanelPositioningTimer !== null) {
            clearTimeout(searchPanelPositioningTimer);
        }
        searchPanelPositioningTimer = setTimeout(function(){
            ssnailSearchPanel.setPosition();
        }, 50);
    }).scroll();
    $(window).ready(function () {
        $(".ssnail-navigation .navbar-toggler").on("click", () => {
            ssnailSearchPanel.close();
        });
        if ($(".ssnail-search-panel.to-be-opened").length > 0) {
            $(this).removeClass("to-be-opened");
            ssnailSearchPanel.open();
        }
    });
} )( jQuery );
